import { render, staticRenderFns } from "./traits.vue?vue&type=template&id=75cac2bc&scoped=true&"
import script from "./traits.vue?vue&type=script&lang=js&"
export * from "./traits.vue?vue&type=script&lang=js&"
import style0 from "./traits.vue?vue&type=style&index=0&id=75cac2bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cac2bc",
  null
  
)

export default component.exports